import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: '', component: LoginComponent, data: { title: 'LOGIN.LOGIN' } },
  { path: 'profile', component: LoginComponent, data: { title: 'LOGIN.YOURINFO' } }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LoginRoutingModule { }

export const routedComponents = [LoginComponent];



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/login/login.routing.ts